export class ContractPageSize {
  static readonly Default = 35;

  static readonly DefaultListView = 25;
}
